module.exports = __webpack_public_path__ + "static/media/sad.a67f6a4f.svg";